import './App.css';
import PanelLeft from "./components/PanelLeft";
import PanelRight from "./components/PanelRight";

function App() {
  return (
    <div className="App">
      <PanelLeft />
      <PanelRight />
    </div>
  );
}

export default App;

